import { render } from "./TheRecommendChart.vue?vue&type=template&id=7055b22c&scoped=true&ts=true"
import script from "./TheRecommendChart.vue?vue&type=script&lang=ts"
export * from "./TheRecommendChart.vue?vue&type=script&lang=ts"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7055b22c"]])

export default __exports__